import React from "react";
import { Reveal, Overline } from "@/components/Reveal";

export const PageHeader = ({ overline, title, subtitle }) => (
  <section className="border-b border-[#E5E5E5] bg-[#FAFAFA]" data-testid="page-header">
    <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-24">
      <Reveal>
        <Overline>{overline}</Overline>
        <h1 className="mt-5 max-w-3xl text-4xl font-bold tracking-tight text-[#0A0A0A] sm:text-5xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#4A4A4A] md:text-lg">
            {subtitle}
          </p>
        )}
      </Reveal>
    </div>
  </section>
);
